var main = require('integrations/main');

main.baseFiles.base = require('./product/base');

main.baseFiles.miniCart = require('./components/miniCart');

main.baseFiles.accessibility = require('./components/accessibility');

main.baseFiles.wishlist = require('./wishlist/wishlist');

require('./myaccount');

module.exports = main;
